import { api } from '../../base';
import {
    IFetchFunnelParams,
    IFetchTimeToHireParams,
    IFetchSourceOfHireParams,
} from '../../common';

export const fetchRecruitmentFunnel = (params: IFetchFunnelParams) => {
    return api.get({ url: 'funnel/', queryParams: params });
};

export const fetchTimeToHireData = (params: IFetchTimeToHireParams) => {
    return api.get({ url: 'recruitment-analytics/', queryParams: params });
};

export const fetchSourceOfHireStats = (params: IFetchSourceOfHireParams) => {
    return api.get({ url: 'hiring-sources/statistics/', queryParams: params });
};

export const fetchSourceOfHireChart = (params: IFetchSourceOfHireParams) => {
    return api.get({ url: 'hiring-sources/piecharts/', queryParams: params });
};
